import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5074f2df&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5074f2df&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074f2df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5074f2df')) {
      api.createRecord('5074f2df', component.options)
    } else {
      api.reload('5074f2df', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5074f2df&scoped=true", function () {
      api.rerender('5074f2df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/simpleTable/index.vue"
export default component.exports